import React, { useEffect, useState } from "react";
import "./Admin.css";
import AdminSidebar from "./comon/AdminSidebar";
import Header from "./comon/Header";
import { Card, CardBody, CardHeader } from "reactstrap";

import {
  CircularProgress,
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";

import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

function PendingUserList() {
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const sendReminder = (email, name) => {
    setLoading(true);
    setSuccess(false);

    fetch(
      "https://idverify.emphasispay.com/api/send-reminder.php?email=" +
        email +
        "&fname=" +
        name,
      { method: "POST" }
    )
      .then((res) => res.json())
      .then(() => {
        setLoading(false);
        setSuccess(true);

        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      });
  };

  useEffect(() => {
    fetch("https://idverify.emphasispay.com/api/get-pending-users.php", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((result) => {
        setUserList(result.result || []);
      });
  }, []);

  return (
    <div className="main-div">
      <AdminSidebar />

      <div className="fill-width">
        <Header />

        <div className="dashboard-container">

          {/* Top Summary */}
          <div className="page-top-box">
            <div>
              <h2>Pending Requests</h2>
              <p>Customers waiting for verification completion.</p>
            </div>

            <div className="user-count-box orange-box">
              <PendingActionsIcon />
              <span>{userList.length} Pending</span>
            </div>
          </div>

          {/* Success Alert */}
          {success && (
            <Alert className="success-alert" severity="success">
              Reminder sent successfully!
            </Alert>
          )}

          {/* Loading */}
          {loading && (
            <div className="loader-overlay">
              <CircularProgress />
            </div>
          )}

          {/* Table */}
          <Card className="table-card">
            <CardHeader className="table-header">
              <h4>Pending Customer List</h4>
            </CardHeader>

            <CardBody className="p-0">

              <TableContainer component={Paper} className="mui-dark-table">
                <Table>

                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Customer</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell align="center">Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {userList.length > 0 ? (
                      userList.map((user, i) => (
                        <TableRow key={i} hover>

                          <TableCell>{i + 1}</TableCell>

                          <TableCell>
                            <div className="table-user">
                              <div className="user-avatar">
                                {user.fname?.charAt(0)}
                              </div>
                              {user.fname}
                            </div>
                          </TableCell>

                          <TableCell>
                            <EmailIcon className="mini-icon" />
                            {user.email}
                          </TableCell>

                          <TableCell>
                            <PhoneIcon className="mini-icon" />
                            {user.phone}
                          </TableCell>

                          <TableCell>
                            <Chip
                              label="Pending"
                              color="warning"
                              size="small"
                            />
                          </TableCell>

                          <TableCell align="center">
                            <button
                              className="reminder-btn"
                              onClick={() =>
                                sendReminder(user.email, user.fname)
                              }
                            >
                              <NotificationsActiveIcon />
                              Send Reminder
                            </button>
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No Pending Requests Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>

                </Table>
              </TableContainer>

            </CardBody>
          </Card>

        </div>
      </div>
    </div>
  );
}

export default PendingUserList;